let home = {
  top: {
    title_1: "Empower big data",
    title_2: "Restoring the Internet with Technology",
    desp: "Unlock real public web data from any website with REAL proxy network",
    btn: {
      start_using: "Start using",
      contact_sales: "Contact sales"
    },
    type: {
      type_1: "5000W+ips",
      type_2: "5000W+ips",
      type_3: "5000W+ips",
      type_4: "5000W+ips",
      type_5: "5000W+ips",
    }
  },
  content: {
    product_solutions: {
      title: "Product Solutions"
    },
    dynamic_house: {
      title: "Dynamic House",
      desp: "A residential proxy is a real user's IP address that allows you to access any website content from a real device, avoiding IP blocking and CAPTCHA verification.·",
      use_btn: "Go to use",
      item: {
        family_house: "2000W family house",
        concurrent_sessions: "Unlimited concurrent sessions",
        legally_acquire: "legally acquire",
        success_rate: "99.9%25 success rate",
        precisely_locate: "Precisely locate countries and cities",
        collect_massive: "Collect massive amounts of public web Data with complete anonymity"
      }
    },
    billing_method: {
      title: "Billing Method",
      desp: "A variety of billing methods to match your business, help you use more favorable",
      flow: "Flow",
      traffic_billing: {
        title: "Traffic Billing",
        desp: "Applicable to business scenarios with less traffic usage and more IP requirements",
        item: {
          item_1: "Charges are deducted according to the traffic used, billed in seconds, how much is deducted as much as you use",
          item_1: "Support for extract use",
          item_1: "Support account password use",
          item_1: "No concurrency limit",
          item_1: "Precisely locate countries and cities",
          item_1: "Monthly use is more favorable",
        }
      },
      ip: "IP",
      ip_billing: {
        title: "IP Billing",
        desp: "Applicable to business scenarios with less traffic usage and more IP requirements",
        item: {
          item_1: "Billed by the number of IPs used, billed in seconds, how much is deducted",
          item_1: "Support for extract use",
          item_1: "Support account password use",
          item_1: "No concurrency limit",
          item_1: "Precisely locate countries and cities",
          item_1: "Monthly use is more favorable",
        }
      }
    },
    scenarios: {
      shade: "SCENARIOS",
      title: "Application Scenarios"
    },
    advantage: {
      title: "Advantage",
      desp: "A variety of billing methods to match your business, help you use more favorable",
      item: {
        item_1: "100% high-quality IP, so that your data collection has no obstacles, no need to worry about being blocked.",
        item_2: "Sending unlimited concurrent requests increases your acquisition speed, cost-effectiveness and overall efficiency.",
        item_3: "Covering more than 200 countries around the world, the number of IPs per day is 2000W+, which perfectly matches your big data applications.",
        item_4: "Professional technical team 7*24h to provide you with technical support to ensure the stable operation of your business",
        item_5: "1V1 exclusive customer service tailor-made solutions for you to collect data more efficiently.",
      }
    },
    partner_warp: {
      title: "partner_warp"
    }
  }
}
export default home


// WEBPACK FOOTER //
// ./src/assets/lang/en/home/index.js